export const ProjectItems = [
  {
    thumbnail:
      "https://live.staticflickr.com/65535/52085464176_fab9fdc458_k.jpg",
    title: "Taste Secure",
    type: "GraphQL (Apollo Server) | Express | MongoDB",
    desc: "A mobile app server to efficiently provide healthy recipes to low income students",
    url: "https://github.com/sohekim/taste-secure",
  },
  {
    thumbnail:
      "https://live.staticflickr.com/65535/52084435632_95ec87d172_k.jpg",
    title: "Suncheck",
    type: "Flutter | SQLite",
    desc: "A cross-platform mobile app to track and manage daily sunlight exposure",
    url: "https://github.com/sohekim/suncheck",
  },
  {
    thumbnail:
    "https://live.staticflickr.com/65535/52288742653_340ffefee8_b.jpg",
    title: "EgoBooster",
    type: "Spring Boot | MySQL | AWS",
    desc: "An API and web server to find, share, and subscribe Ego Boosting quotes",
    url: "https://github.com/sohekim/egobooster",
  },
  {
    thumbnail:
    "https://live.staticflickr.com/65535/52288705513_ae3580b4b3_b.jpg",
    title: "NFT Giftshop",
    type: "Web3 | MetaMask | Next.js | Express",
    desc: "A stealth startup to gift NFT",
    url: "https://docs.google.com/presentation/d/15TgCcUhmznNUooxVQk_71JyVDqA832pfl4oWdW0MWbI/edit?usp=sharing",
  },
  {
    thumbnail:
      "https://cdn.dribbble.com/users/11832276/screenshots/18287837/media/1fedeee6b5e1efdaee01c68f8522f60f.jpeg?compress=1&resize=1200x900&vertical=top",
    title: "ASL Magic Mirror Module",
    type: "Magic Mirror | JavaScript",
    desc: "A module to learn ASL (American Sign Language)",
    url: "https://github.com/marron-sojo/MMM-ASL",
  },
  {
    thumbnail:
      "https://cdn.dribbble.com/users/11832276/screenshots/18287797/media/04b57838333cdda166cea33c88da833c.png?compress=1&resize=1200x900&vertical=top",
    title: "Computer Graphics Playground",
    type: "JavaScript (Three.js) | HTML | CSS",
    desc: "An archieve of computer graphics projects utilizing Three.js library",
    url: "https://github.com/sohekim/graphics",
  },
];
